import { Box, Heading, Text } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { getBookClubCountdownParts } from "../bookClubCountdown";

const units = [
  ["months", "MONTHS"],
  ["days", "DAYS"],
  ["hours", "HOURS"],
  ["minutes", "MINUTES"],
  ["seconds", "SECONDS"],
];

const BookClubCountdown = ({ startsAt, onComplete }) => {
  const [now, setNow] = useState(() => new Date());
  const completedRef = useRef(false);
  const countdown = getBookClubCountdownParts(startsAt, now);

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    if (countdown || !startsAt || completedRef.current) {
      return;
    }

    completedRef.current = true;
    onComplete?.();
  }, [countdown, onComplete, startsAt]);

  if (!countdown) {
    return null;
  }

  return (
    <Box
      bg="gray.900"
      border="1px solid"
      borderColor="gray.800"
      borderRadius="lg"
      p={{ base: "4", md: "5" }}
    >
      <Box
        display="flex"
        alignItems="flex-start"
        justifyContent="center"
        width="100%"
      >
        {units.map(([key, label], index) => (
          <Box key={key} display="flex" alignItems="flex-start" flex="none">
            <Box
              flex="none"
              minW={{ base: "44px", md: "76px" }}
              textAlign="center"
            >
              <Heading
                fontSize={{ base: "2xl", md: "4xl" }}
                lineHeight="1"
                letterSpacing="0.04em"
                sx={{ fontVariantNumeric: "tabular-nums" }}
              >
                {String(countdown[key]).padStart(2, "0")}
              </Heading>
              <Text
                color="gray.400"
                fontSize={{ base: "9px", md: "xs" }}
                fontWeight="bold"
                letterSpacing="0.08em"
                mt="2"
                whiteSpace="nowrap"
              >
                {label}
              </Text>
            </Box>
            {index < units.length - 1 && (
              <Text
                color="gray.500"
                fontSize={{ base: "xl", md: "3xl" }}
                lineHeight="0.8"
                mx={{ base: "1", md: "1.5" }}
              >
                :
              </Text>
            )}
          </Box>
        ))}
      </Box>
      <Text color="gray.400" mt="2" textAlign="center">
        Reading and discussions will open when the Book Club starts.
      </Text>
    </Box>
  );
};

export default BookClubCountdown;
